// extracted by mini-css-extract-plugin
module.exports = {"root":"BlackList_root__11xVU"};